require("@unam-dgae/dgae-mdb/dist/bootstrap.min.js") # TODO: DELETE
#require("@unam-dgae/dgae-mdb/dist/mdb.min.js") # TODO: DELETE
require("@rails/ujs/app/assets/javascripts/rails-ujs.js").start()
require("turbolinks").start()
# require("@rails/activestorage").start()
require("channels")
require('./navbar')

global.$ = require('jquery')

# Uncomment to copy all static images under ../images to the output folder and reference
# them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
# or the `imagePath` JavaScript helper below.
#
# const images = require.context('../images', true)
# const imagePath = (name) => images(name, true)

show_message = (msg, status) ->
  type = switch
    when status == 401 then 'danger'

  document.getElementById('messages')[0].innerHTML '<div role="status" aria-live="polite" class="alert alert-' + type + '">' + msg + '</div>'

document.body.addEventListener 'ajax:error', (e) ->
  [data, status, xhr] = e.detail
  if xhr.status == 401
    show_message data, xhr.status
    setTimeout( ->
      window.location.reload()
    , 4000)
